/**
 * Pipe that validates if there is ome integration
 * available for the selected location
 * on a specific environment. 
 */
import { Pipe, PipeTransform } from '@angular/core';
import { IsGmbEnabledPipe } from './is-gmb-enabled.pipe';
import { IsFacebookEnabledPipe } from './is-facebook-enabled.pipe';
import { LocationsFacadeService } from '@services/locations/locations-facade.service';
import { isGoogle, isFacebook } from '@utilities/function-utils';

@Pipe({
  name: 'someIntegrationEnabled'
})

export class SomeIntegrationEnabledPipe implements PipeTransform {

  constructor(
    private locationFacedeService: LocationsFacadeService
    ) { }

/**
 * Based on a site name (integration name) this function determines if
 * the selected location has some integration enabled within the specific
 * environment depending. Currently it depends on facebookEnabled, facebook_whitelist 
 * gmbEnabled and gmb_whitelist properties set on either environment.ts or 
 * environment.prod.ts.
 * 
 * This pipe will determine if certain HTML components
 * will be shown on the UI for the selected location.
 * 
 * @param siteName Contains the site name or the integration name
 * 
 */
  transform(siteName: string): boolean {
    const facebookEnabledPipe = new IsFacebookEnabledPipe(this.locationFacedeService);
    const gmbEnabledPipe = new IsGmbEnabledPipe(this.locationFacedeService)
    return ((gmbEnabledPipe.transform(true) && isGoogle(siteName) ) || (facebookEnabledPipe.transform(true) && isFacebook(siteName)))
  }

}
